const pleseUpgrade = () => import(/* webpackChunkName:"chunk-pleseUpgrade" */ '../views/P4_Page/Deprecated/index.vue')
const actEnded = () => import(/* webpackChunkName:"chunk-pleseUpgrade" */ '../views/P4_Page/Deprecated/ended.vue')

// prettier-ignore
const routes = [
  {
    path: '/invite-performance', name: 'invite-performance', component: pleseUpgrade
  },
  {
    path: '/intimate-diary', name: 'intimate-diary', component: pleseUpgrade
  },
  {
    path: '/intimate', name: 'intimate', component: pleseUpgrade
  },
  {
    path: '/intimate-rule', name: 'intimate-rule', component: pleseUpgrade
  },
  {
    path: '/invite/boys', name: 'invite-boys', component: pleseUpgrade
  },
  {
    path: '/invite/boys/download', name: 'invite-boys-download', component: pleseUpgrade
  },
  {
    path: '/invite-hostess', name: 'invite-hostess', component: pleseUpgrade
  },
  {
    path: '/invite-hostess-rules', name: 'invite-hostess-rules', component: pleseUpgrade
  },
  {
    path: '/acquisition', name: 'acquisition', component: pleseUpgrade
  },
  {
    path: '/buy-coins', name: 'buy-coins', component: pleseUpgrade
  },
  {
    path: '/echo-pay-store', name: 'echo-pay-store', component: pleseUpgrade
  },
  // 黑色星期五(转盘活动)
  {
    path: '/black-friday', name: 'black-friday', component: actEnded
  },
  // 圣诞
  {
    path: '/christmas-main-male', name: 'christmas-main-male', component: actEnded
  },
  {
    path: '/christmas-rank-male', name: 'christmas-rank-male', component: actEnded
  },
  {
    path: '/christmas-rules-male', name: 'christmas-rules-male', component: actEnded
  },
  {
    path: '/christmas-main-female', name: 'christmas-main-female', component: actEnded
  },
  {
    path: '/christmas-rank-female', name: 'christmas-rank-female', component: actEnded
  },
  {
    path: '/christmas-rules-female', name: 'christmas-rules-female', component: actEnded
  },
  // 开斋节-2026
  {
    path: '/eidalfitr-main-male', name: 'eidalfitr-main-male', component: actEnded
  },
  {
    path: '/eidalfitr-rank-male', name: 'eidalfitr-rank-male', component: actEnded
  },
  {
    path: '/eidalfitr-records-male', name: 'eidalfitr-records-male', component: actEnded
  },
  {
    path: '/eidalfitr-rules-male', name: 'eidalfitr-rules-male', component: actEnded
  },
  {
    path: '/eidalfitr-main-female', name: 'eidalfitr-main-female', component: actEnded
  },
  {
    path: '/eidalfitr-rank-female', name: 'eidalfitr-rank-female', component: actEnded
  },
  {
    path: '/eidalfitr-rules-female', name: 'eidalfitr-rules-female', component: actEnded
  },
  // 法定节假日
  {
    path: '/holiday-main-male-br', name: 'holiday-main-male-br', component: actEnded
  },
  {
    path: '/holiday-rank-male-br', name: 'holiday-rank-male-br', component: actEnded
  },
  {
    path: '/holiday-rules-male-br', name: 'holiday-rules-male-br', component: actEnded
  },
  {
    path: '/holiday-main-female-br', name: 'holiday-main-female-br', component: actEnded
  },
  {
    path: '/holiday-rank-female-br', name: 'holiday-rank-female-br', component: actEnded
  },
  {
    path: '/holiday-rules-female-br', name: 'holiday-rules-female-br', component: actEnded
  },
  // 元旦
  {
    path: '/newyearsday-main-male', name: 'newyearsday-main-male', component: actEnded
  },
  {
    path: '/newyearsday-rank-male', name: 'newyearsday-rank-male', component: actEnded
  },
  {
    path: '/newyearsday-rules-male', name: 'newyearsday-rules-male', component: actEnded
  },
  {
    path: '/newyearsday-main-female', name: 'newyearsday-main-female', component: actEnded
  },
  {
    path: '/newyearsday-rank-female', name: 'newyearsday-rank-female', component: actEnded
  },
  {
    path: '/newyearsday-rules-female', name: 'newyearsday-rules-female', component: actEnded
  },
  // 情人节-2026
  {
    path: '/valentine-main-male', name: 'valentine-main-male', component: actEnded
  },
  {
    path: '/valentine-rank-male', name: 'valentine-rank-male', component: actEnded
  },
  {
    path: '/valentine-rules-male', name: 'valentine-rules-male', component: actEnded
  },
  {
    path: '/valentine-main-female', name: 'valentine-main-female', component: actEnded
  },
  {
    path: '/valentine-rank-female', name: 'valentine-rank-female', component: actEnded
  },
  {
    path: '/valentine-rules-female', name: 'valentine-rules-female', component: actEnded
  },
  // 宰牲节 / 古尔邦节（EidAlAdha）
  {
    path: '/eidaladha-main-female', name: 'eidaladha-main-female', component: actEnded
  },
  {
    path: '/eidaladha-rank-female', name: 'eidaladha-rank-female', component: actEnded
  },
  {
    path: '/eidaladha-rules-female', name: 'eidaladha-rules-female', component: actEnded
  },
  {
    path: '/eidaladha-main-male', name: 'eidaladha-main-male', component: actEnded
  },
  {
    path: '/eidaladha-rank-male', name: 'eidaladha-rank-male', component: actEnded
  },
  {
    path: '/eidaladha-records-male', name: 'eidaladha-records-male', component: actEnded
  },
  {
    path: '/eidaladha-rules-male', name: 'eidaladha-rules-male', component: actEnded
  },
  // SayHi
  {
    path: '/say-hi', name: 'say-hi', component: actEnded
  },
  // 五一活动 2026（MayDay2026）
  {
    path: '/mayday2026-main-male', name: 'mayday2026-main-male', component: actEnded
  },
  {
    path: '/mayday2026-records-male', name: 'mayday2026-records-male', component: actEnded
  },
  {
    path: '/mayday2026-rules-male', name: 'mayday2026-rules-male', component: actEnded
  },
  // 世界杯
  {
    path: '/worldcup-main-female', name: 'worldcup-main-female', component: actEnded
  },
  {
    path: '/worldcup-rank-female', name: 'worldcup-rank-female', component: actEnded
  },
  {
    path: '/worldcup-rules-female', name: 'worldcup-rules-female', component: actEnded
  },
  {
    path: '/worldcup-main-male', name: 'worldcup-main-male', component: actEnded
  },
  {
    path: '/worldcup-rank-male', name: 'worldcup-rank-male', component: actEnded
  },
  {
    path: '/worldcup-records-male', name: 'worldcup-records-male', component: actEnded
  },
  {
    path: '/worldcup-rules-male', name: 'worldcup-rules-male', component: actEnded
  },
  // 活动模板
  {
    path: '/act-template-female-main', name: 'act-template-female-main', component: actEnded
  },
  {
    path: '/act-template-female-rank', name: 'act-template-female-rank', component: actEnded
  },
  {
    path: '/act-template-female-rules', name: 'act-template-female-rules', component: actEnded
  },
  {
    path: '/act-template-male-main', name: 'act-template-male-main', component: actEnded
  },
  {
    path: '/act-template-male-records', name: 'act-template-male-records', component: actEnded
  },
  {
    path: '/act-template-male-rules', name: 'act-template-male-rules', component: actEnded
  },
  // 墨西哥活动
  {
    path: '/act-mexico-female-main', name: 'act-mexico-female-main', component: actEnded
  },
  {
    path: '/act-mexico-female-rank', name: 'act-mexico-female-rank', component: actEnded
  },
  {
    path: '/act-mexico-female-rules', name: 'act-mexico-female-rules', component: actEnded
  },
  {
    path: '/act-mexico-male-main', name: 'act-mexico-male-main', component: actEnded
  },
  {
    path: '/act-mexico-male-records', name: 'act-mexico-male-records', component: actEnded
  },
  {
    path: '/act-mexico-male-rules', name: 'act-mexico-male-rules', component: actEnded
  },
  // 中东嘉年华
  {
    path: '/act-midEast-female-main', name: 'act-midEast-female-main', component: actEnded
  },
  {
    path: '/act-midEast-female-rank', name: 'act-midEast-female-rank', component: actEnded
  },
  {
    path: '/act-midEast-female-rules', name: 'act-midEast-female-rules', component: actEnded
  },
  {
    path: '/act-midEast-male-main', name: 'act-midEast-male-main', component: actEnded
  },
  {
    path: '/act-midEast-male-records', name: 'act-midEast-male-records', component: actEnded
  },
  {
    path: '/act-midEast-male-rules', name: 'act-midEast-male-rules', component: actEnded
  }
]

export default routes
